export const titles = ['Name', 'Email', 'Company', 'Role'];

// Same rule as the employees list: the Name column fits the avatar, a long
// name and the Deactivated badge on one line at every width.
export const template = 'minmax(312px, 1.5fr) repeat(3, minmax(50px, 1fr))';
export const tabletTemplate =
  'minmax(312px, 1.5fr) repeat(2, minmax(50px, 1fr))';

// Phones: name (with its badge) and email each take a full row.
export const cellsMobile = [
  { row: '1/2', col: '1/3' },
  { row: '2/3', col: '1/3' },
  { row: '3/4', col: '1/2' },
  { row: '3/4', col: '2/3' },
];
